import React from 'react';
import { Text, Badge } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';

const SenderEmailCell = (params) => {
    const { data } = params;
    return (
        <div className="sender-email-cell">
            <div className="sender-email-row">
                <Badge type="semanticPositive" size="small">
                    {getLiteral('label_from')}
                </Badge>
                <Text size="small">{data.senderEmail}</Text>
            </div>
            <div className="sender-email-row">
                <Badge type="semanticInfo" size="small">
                    {getLiteral('label_reply_to')}
                </Badge>
                <Text size="small">{data.responseEmail}</Text>
            </div>
        </div>
    );
};

export default SenderEmailCell;
